// components/ConfirmationProvider.tsx
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Typography } from '@mui/material';
import useConfirmationStore from '../../store/confirmationStore';

const ConfirmationProvider: React.FC = () => {
    const { dialog, hideConfirmation } = useConfirmationStore();

    if (!dialog || !dialog.open) return null;

    const { title, message, confirmLabel, cancelLabel, onConfirm, onCancel } = dialog;

    const handleConfirm = () => {
        onConfirm?.();
        hideConfirmation();
    };

    const handleCancel = () => {
        onCancel?.();
        hideConfirmation();
    };

    return (
        <Dialog
            open
            onClose={(_, reason) => {
                if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
            }}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle sx={{ textAlign: 'center', fontWeight: 600 }}>{title}</DialogTitle>
            <DialogContent>
                <Stack spacing={1} alignItems="center" sx={{ py: 1 }}>
                    <Typography variant="body1" align="center" color="text.secondary">
                        {message}
                    </Typography>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" width="100%" sx={{ pb: 2 }}>
                    <Button variant="outlined" onClick={handleCancel}>
                        {cancelLabel ?? 'Cancel'}
                    </Button>
                    <Button variant="contained" color="error" onClick={handleConfirm}>
                        {confirmLabel ?? 'Confirm'}
                    </Button>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationProvider;
